export const PHONE_NUMBER = '0999 228 5498';
export const LOCATION_ADD = 'Quilaton Law Office, The Office, 2nd Floor, JY Square Mall, Lahug, Cebu City, Cebu, Philippines 6000';
export const EMAIL_ADD = 'appointment@quilatonlawoffice.com';
export const PHONE = "+639992285498";
// Same-origin by default prevents www/non-www CORS mismatches in production.
// Set REACT_APP_API_URL locally only when the API is hosted on a separate development origin.
export const PROXY = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
export const OFFICE_HOURS = 'Mon - Fri 09 AM - 06 PM';
